import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { MAX_EXPORT_RECORDS } from '../../../../helpers/constants';

const escapeCsvValue = (value) => {
  const str = String(value ?? '');
  if (str.includes(';') || str.includes('"') || str.includes('\n')) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
};

const CSV_HEADERS = [
  "Nombre y Apellido", "Fecha Postulación", "Equipo Comercial", "Asesor",
  "Soporte Comercial", "Compliance", "Estado", "Fecha Pase a Compliance",
  "Contrato", "Cliente Balanz"
];

const mapRowToCsv = (c) => [
  c.complete_name,
  c.application_date,
  c.status_commercial_team,
  c.adviser_username,
  c.status_commercial_support,
  c.status_compliance,
  c.prospect_status,
  c.compliance_date,
  c.contract_short_name,
  c.is_balanz === 1 ? "Si" : "No",
].map(escapeCsvValue).join(';');

export const ExportCsvButton = ({ fetchExportData, totalCount }) => {
  const [loading, setLoading] = useState(false);

  const handleExport = async () => {
    setLoading(true);
    try {
      const data = await fetchExportData();
      const rows = data.map(mapRowToCsv);
      const csvContent = [CSV_HEADERS.join(';'), ...rows].join('\n');
      const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      const dateStamp = new Date().toISOString().slice(0, 10);
      link.download = `candidatos_${dateStamp}.csv`;
      link.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error al exportar CSV', error);
    } finally {
      setLoading(false);
    }
  };

  const exceedsMax = totalCount > MAX_EXPORT_RECORDS;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <button
        className='btn btn-sm header_btn_logout'
        onClick={handleExport}
        disabled={loading || totalCount === 0}
      >
        <FontAwesomeIcon icon={faFileExcel} className="me-2" />
        {loading ? 'Generando...' : `Descargar CSV (máx. ${MAX_EXPORT_RECORDS})`}
      </button>

      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip id="export-csv-tooltip">
            Se descargan hasta {MAX_EXPORT_RECORDS} registros según los filtros aplicados.
            {exceedsMax
              ? ` Hay ${totalCount} resultados con estos filtros: para obtener el resto, precisá la búsqueda (ej: por nombre y apellido, o filtrando por estado).`
              : ' Si hay más de 100 resultados, buscar (por nombre, asesor o estado) para acotar el listado.'}
          </Tooltip>
        }
      >
        <span style={{ cursor: 'pointer', color: exceedsMax ? '#d9822b' : '#6c757d' }}>
          <FontAwesomeIcon icon={faInfoCircle} />
        </span>
      </OverlayTrigger>
    </div>
  );
};